var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamMenuAlpine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 600,
    viewBox: "0 0 440 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_555)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_555)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_555",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2400,
    height: 800
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2400 0H0V800H2400V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 687.54L777.16 58.466H1268.83L300.331 819.329L-23.587 818.53V687.54Z",
    fill: "url(#paint0_linear_3_555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.44 -12.141L324.122 625.24H777.567L1589.9 -12.939L1135.44 -12.141Z",
    fill: "url(#paint1_linear_3_555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 513.738L368.856 205.431H748.286L-27.857 815.176L-23.587 513.738Z",
    fill: "url(#paint2_linear_3_555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.232 817.891L709.245 434.505H1158.22L667.052 820.367L221.232 817.891Z",
    fill: "url(#paint3_linear_3_555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.019 -12.939L160.942 435.703H592.122L1165.49 -14.736L732.019 -12.939Z",
    fill: "url(#paint4_linear_3_555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.143 -12.939L66.593 228.674H637.67L952.26 -18.47L374.143 -12.939Z",
    fill: "url(#paint5_linear_3_555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.8 -10.224L130.492 298.762H-178.938L219.529 -14.277L523.8 -10.224Z",
    fill: "url(#paint6_linear_3_555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.938 449.84L194.608 156.38H622.623L-171.522 780.267L-178.938 449.84Z",
    fill: "url(#paint7_linear_3_555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.674 -18.47L-78.895 412.49H280.976L828.052 -17.297L469.674 -18.47Z",
    fill: "url(#paint8_linear_3_555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.857 815.176L298.789 558.56H735.272L405.923 817.299L-27.857 815.176Z",
    fill: "url(#paint9_linear_3_555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 369.04H422.944L-34.447 728.37L-23.587 369.04Z",
    fill: "url(#paint10_linear_3_555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.227 -29.228L-93.73 423.248V-26.744L482.227 -29.228Z",
    fill: "url(#paint11_linear_3_555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.944 -121.136L-153.012 331.34V-118.652L422.944 -121.136Z",
    fill: "url(#paint12_linear_3_555)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M2400 0H0V800H2400V0Z",
    fill: "#0C78BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9902 287.024H84.7712L52.7974 251.995L20.8236 287.024H31.6046L37.2905 280.595H68.2305L73.9902 287.024ZM52.7974 263.154L62.84 274.461H42.8287L52.7974 263.154ZM176.927 259.163H204.691C210.23 259.163 211.928 260.863 211.928 264.41C211.928 267.588 209.565 269.51 204.765 269.51H176.927V259.163ZM254.978 253.103H245.822V287.024H254.978V253.103ZM331.11 253.103V274.018L293.229 253.103H283.998V287.024H292.49V261.972L339.676 287.985V253.103H331.11ZM167.844 253.103V287.024H177.001V275.643H206.538C217.54 275.643 221.749 271.061 221.749 264.189C221.749 257.611 217.097 253.029 206.907 253.029H167.844V253.103ZM113.644 280.89V253.103H104.487V287.024H146.061L148.645 280.89H113.644ZM377.852 280.89V272.835H414.995V266.701H377.852V259.163H414.995V253.029H368.696V286.95H414.478L416.176 280.817H377.852V280.89Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.059 320.871L162.38 327.005H202.993L210.746 320.871H170.059Z",
    fill: "#0078C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.747 320.871L202.993 327.005H222.709L230.462 320.871H210.747Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.462 320.871L222.709 327.005H266.793L274.546 320.871H230.462Z",
    fill: "#DA291C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_555",
    x1: 900.323,
    y1: 136.714,
    x2: 220.425,
    y2: 715.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_555",
    x1: 1272.85,
    y1: -137.826,
    x2: 761.393,
    y2: 581.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_555",
    x1: 64.8378,
    y1: 608.483,
    x2: 513.999,
    y2: 232.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_555",
    x1: 360.898,
    y1: 964.812,
    x2: 866.563,
    y2: 444.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_555",
    x1: 276.23,
    y1: 500.058,
    x2: 646.348,
    y2: 223.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_555",
    x1: 200.656,
    y1: 336.248,
    x2: 496.014,
    y2: 115.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_555",
    x1: -97.0263,
    y1: 345.774,
    x2: 160.629,
    y2: 153.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_555",
    x1: -214.997,
    y1: 637.815,
    x2: 132.876,
    y2: 377.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3_555",
    x1: 20.1718,
    y1: 462.726,
    x2: 359.101,
    y2: 209.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3_555",
    x1: 560.964,
    y1: 452.869,
    x2: 185.719,
    y2: 876.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3_555",
    x1: -34.4468,
    y1: 548.705,
    x2: 422.944,
    y2: 548.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3_555",
    x1: -52.7464,
    y1: 236.907,
    x2: 146.834,
    y2: 22.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3_555",
    x1: -120.145,
    y1: 194.088,
    x2: 66.3138,
    y2: -35.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB5BA1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 800,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMenuAlpine);
export default __webpack_public_path__ + "static/media/team_menu_alpine.f581f79ba62b8ef365bb2b4a96b04fe8.svg";
export { ForwardRef as ReactComponent };